import React, { Component, Fragment } from 'react';
import { IconButton, DirectionalHint, TooltipHost, TooltipDelay, DefaultButton, Modal, Callout, Spinner, SpinnerSize } from '@fluentui/react';
import Plans from './Plans'
import CheckOut from './CheckOut'
import { connect } from 'react-redux';

function capital_letter(str) {
    str = str.split(" ");

    for (var i = 0, x = str.length; i < x; i++) {
        str[i] = str[i][0].toUpperCase() + str[i].substr(1);
    }

    return str.join(" ");
}
export class UpgradeModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 'plans'
        };
        this.changeStep = this.changeStep.bind(this);
    }

    componentDidMount() {
    }

    changeStep(step, type, product, productId) {
        
        this.setState({
            step: step,
            type: type,
            product: product,
            productId: productId
        })
    }

    render() {
        return (
            <Fragment>
                <Modal
                    isOpen={this.props.open}
                    isBlocking={false}
                    setInitialFocus={false}
                    onDismiss={this.props.handleClose}
                    className="dark-overlay"
                    firstFocusableSelector="blah"
                    disableFirstFocus={true}
                >
                    <div class="account-settings-modal" style={{ height: 500, width:700 } }>
                        <div class="modal-content" role="document" style={{ backgroundColor:'rgba(var(--palette-neutral-100), 0.03)'} }>
                            <div class="pt15 pr20 displayflex" style={{justifyContent:'flex-end'} }>
                                <IconButton
                                    className=""
                                    styles={{
                                        icon: { fontSize: 26, },
                                    }}
                                    iconProps={{ iconName: 'Cancel' }}
                                    onClick={this.props.handleClose}
                                />
                            </div>
                            <div class="modal-body" style={{padding:20} }>
                                <div id="account-settings-modal-tabs" class="account-settings-modal__content">
                                    <div class="" >
                                        <div id="account-settings-modal-tabs-pane-account" class="flexcolumn aligncenter" style={{ width: '580px', margin: 'auto',  }}>
                                           
                                            <h1 className="mt0 mb30 text-dark-to-light">Choose Your Pricing Plan</h1>
                                            <div class="profile-overview">
                                                <CheckOut changeStep={this.changeStep} type={this.state.type} product={"scheduler"} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    product: state.appState.product.slug
});

export default connect(mapStateToProps)(UpgradeModal);



